<script lang="ts" setup>
import SidebarFooter from "./components/SidebarFooter.vue";
import SidebarHeader from "./components/SidebarHeader.vue";
import SidebarNav from "./components/SidebarNav.vue";
import { useSidebar } from "./composables/useSidebar";
import SidebarMobile from "./NavigationSidebarMobile.vue";
import type { SidebarConfig } from "./types";

interface Props {
  /** Sidebar configuration */
  config: SidebarConfig
}

defineProps<Props>();

const { isCollapsed } = useSidebar();
</script>

<template>
  <div>
    <!-- Desktop Sidebar - shown on lg+ screens -->
    <aside
      :class="{
        'w-64': !isCollapsed,
        'w-20': isCollapsed,
      }"
      aria-label="Main navigation"
      class="sidebar sidebar-flat fixed top-0 left-0 h-screen
             flex flex-col transition-all duration-300 ease-in-out z-40
             hidden lg:flex"
    >
      <!-- Header -->
      <SidebarHeader
        :brand-name="config.brandName"
        :logo="config.logo"
      />

      <!-- Navigation -->
      <SidebarNav :items="config.items" />

      <!-- Footer -->
      <SidebarFooter
        :items="config.footerItems"
        :show-theme-toggle="config.showThemeToggle"
        :show-user-menu="config.showUserMenu"
      />
    </aside>

    <!-- Mobile Sidebar - shown on <lg screens -->
    <div class="lg:hidden">
      <SidebarMobile :config="config" />
    </div>
  </div>
</template>

<style lang="scss">
@use 'assets/styles/sidebar';
</style>
